import { Component, OnInit, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { KEYCLOAK_EVENT_SIGNAL, KeycloakEventType, typeEventArgs } from 'keycloak-angular';
import { MenuComponent } from "./menu/menu.component";
import { HomeComponent } from "./home/home.component";
import { AppLayoutComponent } from "shared-lib";
import { LicensePlateCacheService } from './shared/license-plate-cache.service';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppLayoutComponent, MenuComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'JJames Smart Parking - Operator Dashboard';
  private keycloakEvent = inject(KEYCLOAK_EVENT_SIGNAL);
  private licensePlateCache = inject(LicensePlateCacheService);

  constructor() {
    // Load the shared plate list once the user is logged in; drop it on logout.
    effect(() => {
      const event = this.keycloakEvent();
      if (event.type === KeycloakEventType.Ready && typeEventArgs<boolean>(event.args)) {
        this.licensePlateCache.load();
      } else if (event.type === KeycloakEventType.AuthSuccess) {
        this.licensePlateCache.load();
      } else if (event.type === KeycloakEventType.AuthLogout) {
        this.licensePlateCache.clear();
      }
    });
  }

  ngOnInit(): void {
  }

}
